import { useState, useEffect } from "react"
import { enqueueSnackbar } from "notistack"

import { paths } from "src/routes/paths"

import useNavigate from "src/hooks/use-navigate"
import { useBoolean } from "src/hooks/use-boolean"

import { api } from "src/utils/axios"
import { jwtDecode } from "src/utils/isValidToken"

import { useAuthStore } from "src/auth/auth.store"
import { useMyInterestsStore } from "src/stores/my-interests/my-interests.store"
import { MyInterestsRepository } from "src/repositories/my-interests/my-interests.repository"

import { MyInterestQuestion } from "src/types/my-interests/my-interests"


export const useMyInterestQuiz = (sendingMyInterests: any) => {
    const [allQuestions, setAllQuestions] = useState<MyInterestQuestion[]>([])
    const [question, setQuestion] = useState<MyInterestQuestion>()
    const [step, setStep] = useState(0)
    const [interests, setInterests] = useState<string[]>([])
    const [selectedInterest, setSelectedInterest] = useState<string>()

    const setUseMyInterestsDialog = useMyInterestsStore((state) => state.setUseMyInterestsDialog)
    const replyAgain = useMyInterestsStore((state) => state.replyAgain)
    const accessToken = useAuthStore((state) => state.accessToken)

    const navigate = useNavigate()

    const isLoadingQuestions = useBoolean(true)

    const profileData = jwtDecode(accessToken ?? '')?.data?.profileData
    const isInterestSelected = selectedInterest;
    const quizProgress = (step / (allQuestions.length - 1)) * 100

    const myInterestRepository = new MyInterestsRepository(api)

    const getQuestions = async () => {
        isLoadingQuestions.onTrue()
        try {
            const response = await myInterestRepository.getQuizQuestions((replyAgain && !profileData?.secondary && profileData?.main) || (!replyAgain && profileData?.main) ? profileData.main : undefined)
            if (response.isLeft()) {
                throw new Error(response.value.message)
            }
            setAllQuestions(response.value)
            setQuestion(response.value[0])
        } catch {
            enqueueSnackbar({ message: 'Ocorreu um erro ao carregar os interesses.', variant: 'error' })
        } finally {
            setTimeout(() => {
                isLoadingQuestions.onFalse()
            }, 300)
        }
    }

    const handleNextQuestion = async () => {
        if (step < allQuestions.length - 1) {
            if(selectedInterest){
                setQuestion(allQuestions[step + 1])
                setStep((prev) => prev + 1)
                setSelectedInterest(undefined)
            }
        } else {
            sendingMyInterests.onTrue()
            try {
                const response = await myInterestRepository.sendMyInterests(interests, !!profileData?.main && !replyAgain)
                if (response.isLeft()) {
                    throw new Error(response.value.message)
                }
            } catch (error) {
                enqueueSnackbar({ message: error, variant: 'error' })
            } finally {
                navigate(paths.myInterestsResult.root)
                setTimeout(() => {
                    window.location.reload()
                    setUseMyInterestsDialog(false)
                }, 500)
            }
        }
    }

    const handleSelectInterest = (interest: string) => {
        setSelectedInterest(interest)
        setInterests((prev) => [...prev, interest])
    }

    useEffect(() => {
        getQuestions()
    }, [])

    return {
        question,
        quizProgress,
        sendingMyInterests,
        isLoadingQuestions,
        isInterestSelected,
        handleSelectInterest,
        handleNextQuestion,
    }
}
